module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"limit":"محدود","stop-limit":"حد توقف","oco":"ترکیبی","market":"سریع"}}')
  delete Component.options._Ctor
}
